import type { NodeRedFlow } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

export default function omitComponentInstanceOuterLogicFlows(flows: NodeRedFlow[], componentId: string): NodeRedFlow[] {
  return flows.filter((flow) => {
    const z = 'z' in flow ? flow.z : null;
    return !z || !z.includes(componentId) || z.includes(':isolated');
  });
}
